import {ModuleWithProviders, NgModule} from '@angular/core';

import {SpringboardComponentLibraryComponent} from './springboard-component-library.component';
import {ButtonsModule} from './buttons/buttons.module';
import {CustomIconsModule} from './custom-icons/custom-icons.module';
import {SlidersModule} from './sliders/sliders.module';
import {TabsModule} from './tabs/tabs.module';
import {TextInputsModule} from './text-inputs/text-inputs.module';
import {BadgesModule} from './badges';
import {BulletModule} from './bullet/bullet.module';
import {ModalModule} from './modal/modal.module';
import {LinkModule} from './link/link.module';

export * from 'springboard-component-library/src/lib/tabs';
export * from 'springboard-component-library/src/lib/buttons';
export * from 'springboard-component-library/src/lib/custom-icons';
export * from 'springboard-component-library/src/lib/sliders';
export * from 'springboard-component-library/src/lib/text-inputs';
export * from 'springboard-component-library/src/lib/badges';
export * from 'springboard-component-library/src/lib/bullet';
export * from 'springboard-component-library/src/lib/link';
export * from 'springboard-component-library/src/lib/modal';

@NgModule({
  declarations: [
    SpringboardComponentLibraryComponent,
  ],
  imports: [],
  exports: [
    ButtonsModule,
    TabsModule,
    CustomIconsModule,
    SlidersModule,
    TextInputsModule,
    BadgesModule,
    BulletModule,
    LinkModule,
    ModalModule,
    SpringboardComponentLibraryComponent,
  ],
})

export class SpringboardComponentLibraryModule {

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SpringboardComponentLibraryModule,
    };
  }
}
